export default function v1FooterCta() {
  document.addEventListener('DOMContentLoaded', function() {
    const img = document.querySelector('.v1-footerCta__bannerImage');
    if (!img) return;
    const source = document.querySelector('.v1-footerCta__banner picture source');
    const isPc = window.innerWidth >= 768;

    img.addEventListener('mouseover', function() {
      if (isPc) {
        if (source.srcset.includes('.png')) {
          source.srcset = source.srcset.replace('.png', '_hover.png');
        }
      }
    });

    img.addEventListener('mouseout', function() {
      source.srcset = source.srcset.replace('_hover.png', '.png');
    });
  });
}
